import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileTriggerService } from "../../services/profile-trigger.service";

export const listProfileTriggerByProfileId = createAsyncThunk(
  "profileTriggerManage/listProfileTriggerByProfileId",
  async ({ profileId, filter }, { rejectWithValue }) => {
    try {
      const response =
        await profileTriggerService.listProfileTriggerByProfileId(
          profileId,
          filter
        );

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addProfileTrigger = createAsyncThunk(
  "profileTriggerManage/addProfileTrigger",
  async (data, { rejectWithValue }) => {
    try {
      const response = await profileTriggerService.addProfileTrigger(data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editProfileTrigger = createAsyncThunk(
  "profileTriggerManage/editProfileTrigger",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await profileTriggerService.editProfileTrigger(id, data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeProfileTriggerPosition = createAsyncThunk(
  "profileTriggerManage/changeProfileTriggerPosition",
  async (data, { rejectWithValue }) => {
    try {
      const response = await profileTriggerService.changeProfileTriggerPosition(data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeProfileTrigger = createAsyncThunk(
  "profileTriggerManage/removeProfileTrigger",
  async (id, { rejectWithValue }) => {
    try {
      const response = await profileTriggerService.removeProfileTrigger(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const readProfileTrigger = createAsyncThunk(
  "profileTriggerManage/readProfileTrigger",
  async (id, { rejectWithValue }) => {
    try {
      const response = await profileTriggerService.readProfileTrigger(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
